/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./learderboard.vue?vue&type=template&id=757769b8&scoped=true"
import script from "./learderboard.vue?vue&type=script&lang=js"
export * from "./learderboard.vue?vue&type=script&lang=js"
import style0 from "./learderboard.vue?vue&type=style&index=0&id=757769b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757769b8",
  null
  
)

export default component.exports